<template>
  <div>
    <v-row class="mb-3" align="center"
      justify="center">
        <v-col lg="4" sm="6" cols="12">
          <v-autocomplete
            auto-select-first
            :label="$t('Employee')"
            :items="selectUsers"
            :placeholder="$t('Select an option')"
            v-model="configDatatale.paramsRequest.user_id"
            clearable
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-col lg="4" sm="5" cols="12">
          <v-row>
             <v-col md="6">
                <datepicker v-model="configDatatale.paramsRequest.from_date" :label="$t('From date')"/>
             </v-col>
             <v-col md="6">
               <datepicker v-model="configDatatale.paramsRequest.to_date" :label="$t('To date')"/>
             </v-col>
          </v-row>
        </v-col>
        <v-col lg="3" sm="5" cols="12">
          <v-text-field
            v-model="configDatatale.paramsRequest._search"
            append-icon="mdi-magnify"
            :label="$t('Key word')"
            outlined
            dense
            hide-details
            @keydown.enter="handleSearch($event)"
          />
        </v-col>
        <v-col lg="1" sm="2" cols="12">
          <v-btn
            color="primary"
            medium
            outlined
            @click="handleSearch($event)"
          >
            {{ $t('Search') }}
          </v-btn>
        </v-col>
    </v-row>
    <datatable ref="reportDatatable" :config="configDatatale"/>
  </div>
</template>

<script>
import Datatable from '@/components/Datatable'
import Datepicker from '@/components/Datepicker'
import { utcToLocal, parseHtmlEntities } from '@utils'
import { get, call } from 'vuex-pathify'

export default {
  name: 'ReportIndex',
  components: {
    Datatable,
    Datepicker
  },
  data: (vm) => ({
    configDatatale: {
      url: '/api/admin/report/task-records',
      queryBuilder: {
        _include: ['task.user', 'task.project']
      },
      columns: [
        {
          text: 'ID',
          data: 'id',
          name: 'id'
        },
        {
          text: vm.$t('Task Name'),
          data: 'task.name',
          name: 'task.name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'my-workings.detail', params: {id:${item.task.id}} }">${item.task.name}</router-link>`
          }
        },
        {
          text: vm.$t('Project Name'),
          data: 'task.project.name',
          name: 'task.project.name',
          component: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return `<router-link :to="{ name: 'projects.show', params: {id:${item.task.project_id}} }">${item.task.project.name}</router-link>`
          }
        },
        {
          text: vm.$t('Employee'),
          data: 'task.user.name',
          name: 'task.user.name'
        },
        {
          text: vm.$t('Result'),
          data: 'result',
          name: 'result'
        },
        {
          text: vm.$t('Detail'),
          data: 'detail',
          name: 'detail',
          html: true,
          render: function(item, column) {
            if (!item) {
              return null
            }
            return parseHtmlEntities(item[column])
          }
        },
        {
          text: vm.$t('Created at'),
          data: 'created_at',
          name: 'created_at',
          render: function(item, column) {
            if (!item) {
              return null
            }
            return utcToLocal(item[column], 'DD/MM/YYYY HH:mm')
          }
        }
      ],
      setting: {
        displaySearchInput: false,
        operationStyle: 'default'
      },
      paramsRequest: {
        from_date: null,
        to_date: null,
        user_id: null,
        _search: null
      }
    }
  }),
  mounted() {
    this.fetchAllUsers()
  },
  computed: {
    selectUsers: get('user/selectUsers')
  },
  methods: {
    fetchAllUsers: call('user/all'),

    handleSearch(e) {
      e.preventDefault()
      const filter = {
        ...this.configDatatale.paramsRequest
      }
      this.$refs.reportDatatable.setParamsRequest(filter)
      this.$refs.reportDatatable.fetchData()
      return false
    }
  }
}
</script>
